// extracted by mini-css-extract-plugin
export default {"outerDiv":"OrderHistory_outerDiv__yMEti","innerDiv":"OrderHistory_innerDiv__4Uz5+"};